import { create } from "zustand";
import { persist, createJSONStorage } from 'zustand/middleware';
import { PreSignUpConfig, type TConfigState } from '../storage/store';
import { OnlyPreSignUpConfig } from "../interfaces/PublicConfig";
import { SignUpData } from "../interfaces/SignUpData";
import LocalStorageWrapper from "../common/@database/localStorage";
import { USER_PRESIGNUP } from "../appConstants/AppConstant";
import { OnlyPostSignUpConfig } from "../interfaces/PrivateConfig";
import { HomeScreenConfig } from "../interfaces/TournamentsConfig";

const initialTokenState = {
  preSignupConfig: {} as PreSignUpConfig
};

export const useConfigStore = create<TConfigState>()(
  persist(
    (set) => ({
      ...initialTokenState,
      // resetTokenStore: () => set((state) => {
      //   console.log('state', state)
      //   return state
      //   // return {
      //   //   ...initialTokenState,
      //   //   data: state.
      //   //   // serialNumber: state.serialNumber,
      //   //   // language: state.language,
      //   // };
      // }),
    }),
    {
      name: USER_PRESIGNUP,
      storage: createJSONStorage(
        () =>
          new LocalStorageWrapper(),
      ),
    },
  ),
)

export function dispatchSignUpData(signUpData: SignUpData) {
  const state = useConfigStore.getState();
  useConfigStore.setState({ ...state, signUpData });
}

export function dispatchPreSignupConfig(preSignupConfig: PreSignUpConfig) {
  const state = useConfigStore.getState();
  useConfigStore.setState({ ...state, preSignupConfig });
}

export function dispatchPostSignupConfig(postSignupConfig: OnlyPostSignUpConfig) {
  const state = useConfigStore.getState();
  useConfigStore.setState({ ...state, postSignupConfig });
}

export function dispatchHomeScreenConfig(homeScreenConfig: HomeScreenConfig) {
  const state = useConfigStore.getState();
  useConfigStore.setState({ ...state, homeScreenConfig });
}